export const initialState = {
  loading: false,
  responsive: {
    viewDesktopLists: true,
    viewDesktopSpecial: true,
    viewDesktopFilters: true,
  },
  roles: {},
  newContractData: {
    product: {
      id: "",
      supplier: "",
      brand: "",
      model: "",
      capacity: "",
      color: "",
      price: "",
      nQuotas: "",
      quotaPrice: "",
      stock: "",
    },
    customer: {
      name: "",
      surname1: "",
      surname2: "",
      birthdate: "",
      email: "",
      phone: "",
      fixPhone: "",
      documentNumber: "",
      documentType: "",
      language: "",
      deliveryAddress: {
        street: "",
        number: "",
        door: "",
        floor: "",
        stair: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
      },
      billingAddress: {
        sameAddress: false,
        street: "",
        number: "",
        door: "",
        floor: "",
        stair: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
      },
    },
  },
  newPromotionData: {
    name: "",
    tenant: [],
    description: "",
    legal_conditions: "",
    channel: [],
    type: "",
    units_limit: "",
    start_date: "",
    end_date: "",
    start_actived_date: "",
    end_actived_dat: "",
    priority: 1,
    autoAssignment: false,
    cumulative: false,
    cumulativeCustumer: false,
    applyToRentServ: false,
    version: "1",
    status: "PENDING",
    criteria: {
      name: "",
      condition: "",
      parameters: null,
    },
    products: [],
    customers: {
      legal_identifier: [],
    },
    vouchers: {
      voucher_code: "",
      use_limit: "",
    },
    feeDiscounts: [
      {
        feeNumber: "",
        discountType: "",
        value: "",
      }
    ],
  },
  recoveryData: {
    promoType: "",
    brand: "",
    model: "",
    capacity: "",
    color: "",
    discountTypeName: "",
    feeTotalNumber: null,
    executionType: "",
    fee1: {},
    fee2: {},
    fee3: {},
    fee4: {},
    fee5: {},
    fee6: {},
    fee7: {},
    fee8: {},
    fee9: {},
    fee10: {},
    fee11: {},
    fee12: {},
    fee13: {},
    fee14: {},
    fee15: {},
    fee16: {},
    fee17: {},
    fee18: {},
    fee19: {},
    fee20: {},
    fee21: {},
    fee22: {},
    fee23: {},
    fee24: {},
    fee25: {},
    fee26: {},
    fee27: {},
    fee28: {},
    fee29: {},
    fee30: {},
    fee31: {},
    fee32: {},
    fee33: {},
    fee34: {},
    fee35: {},
    fee36: {},
  },
  contractInfo: {},
};

export const rolesPredefinidos = [
  'sinRol',
  'super_admin',
  'admin',
  'security_mantainer',
  'Backoffice_member',
  'Backoffice_supervisor',
  'Backoffice_member_empresas',
  'Backoffice_admin',
  'Backoffice_Superadmin'
];